export interface IntegrationsMarketplaceGridAvailableWebComponentSchema {
  // all the data needed for rendering
}
export enum IntegrationInstancesMethods {
  READ_RECORDS = 'readRecords',
}
